import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getDesignations = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Designation/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching designations:", error);
    throw error;
  }
};

export const saveDesignation = async (designation) => {
  const response = await axios.post(`${BASE_URL}/api/Designation/save`, designation, {
    headers: getAuthHeader(),
  });
  return response.data;
};
